var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1767929473582,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2650,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 160h816v144H128z",
    fill: "#95EAFF",
    "p-id": 2651
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544 576m-176 0a176 176 0 1 0 352 0 176 176 0 1 0-352 0Z",
    fill: "#95EAFF",
    "p-id": 2652
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M880 288H144a16 16 0 0 0 0 32h736a16 16 0 0 0 0-32zM512 384c-106.032 0-192 85.968-192 192s85.968 192 192 192 192-85.968 192-192-85.968-192-192-192z m0 352c-88.368 0-160-71.632-160-160s71.632-160 160-160 160 71.632 160 160-71.632 160-160 160z",
    fill: "#49A3FE",
    "p-id": 2653
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M513.28 833.232m-17.232 0a17.232 17.232 0 1 0 34.464 0 17.232 17.232 0 1 0-34.464 0Z",
    fill: "#49A3FE",
    "p-id": 2654
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 576m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#49A3FE",
    "p-id": 2655
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M928 128h-48.976A15.536 15.536 0 0 0 880 123.2V80a16 16 0 0 0-32 0v43.2c0 1.712 0.48 3.264 0.976 4.8H175.024A15.536 15.536 0 0 0 176 123.2V80a16 16 0 0 0-32 0v43.2c0 1.696 0.48 3.264 0.976 4.8H96a16 16 0 0 0-16 16v128a16 16 0 0 0 32 0v-112h800v105.856a16 16 0 0 0 32 0V144a16 16 0 0 0-16-16zM838.112 305.728l25.984 238.352C864 736.768 706.4 894.352 512 894.352s-352-157.6-352-352l23.84-234.704-31.84-3.216-23.92 236.32C128 754.432 299.92 926.352 512 926.352s384-171.92 384-384l-26.08-240.096-31.808 3.472z",
    fill: "#0F13AE",
    "p-id": 2656
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M624 576a112 112 0 1 0-224 0 112 112 0 0 0 224 0z m-192 0a80 80 0 1 1 160.016 0.016A80 80 0 0 1 432 576z",
    fill: "#0F13AE",
    "p-id": 2657
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.c5addb81efd3906c4f85ecbe909282f7.svg";
export { ForwardRef as ReactComponent };